module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex justify-center h-100 flex-column no-data"
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f4 black tl"
  }, [_vm._v("\n    Recommended Plan\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center items-center h-100 flex-column inside-data"
  }, [_c('no-device-icon', {
    staticClass: "no-device-icon"
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cera-round-pro-medium f4 black mt3"
  }, [_vm._v("\n        No Device Selected\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "inter silver f6 mt3"
  }, [_vm._v("\n        Select A Device to View\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "inter silver f6 mt2"
  }, [_vm._v("\n        The Recommended Plan\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-585195f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/summaryBox/NoDeviceData.vue
// module id = 689
// module chunks = 0